import { createContext, useCallback, useEffect, useState } from "react";
import { themeData } from "../data/themeData";
export const ThemeContext = createContext();

const COLOR_KEY = "themeColor";
const DARK_MODE_KEY = "themeDarkMode";
const DEFAULT_COLOR = "blue";
const DEFAULT_DARK_MODE = true;

const readStorage = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // localStorage indisponível (ex.: modo privado); segue sem persistir
  }
};

const getInitialColor = () => {
  const color = readStorage(COLOR_KEY);
  return color && themeData.theme[`${color}Dark`] ? color : DEFAULT_COLOR;
};

const getInitialDarkMode = () => {
  const darkMode = readStorage(DARK_MODE_KEY);
  return darkMode === null ? DEFAULT_DARK_MODE : darkMode === "true";
};

const getTheme = (isDarkMode, color) =>
  themeData.theme[`${color}${isDarkMode ? "Dark" : "Light"}`] ||
  themeData.theme.blueDark;

function ThemeContextProvider(props) {
  const [colorTheme, setColorTheme] = useState(getInitialColor);
  const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode);
  // Tema temporário que não é salvo (ex.: páginas do futsal forçam azul claro)
  const [overrideTheme, setOverrideTheme] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const theme = overrideTheme || getTheme(isDarkMode, colorTheme);

  useEffect(() => {
    writeStorage(COLOR_KEY, colorTheme);
  }, [colorTheme]);

  useEffect(() => {
    writeStorage(DARK_MODE_KEY, String(isDarkMode));
  }, [isDarkMode]);

  const setHandleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const changeColor = (color) => {
    setOverrideTheme(null);
    setColorTheme(color);
  };

  const toggleDarkMode = () => {
    const newMode = !(overrideTheme ? overrideTheme.type === "dark" : isDarkMode);
    setOverrideTheme(null);
    setIsDarkMode(newMode);
  };

  // forceTheme(null) remove o tema temporário e volta ao escolhido pelo usuário
  const forceTheme = useCallback((isDark, color) => {
    setOverrideTheme(isDark === null ? null : getTheme(isDark, color));
  }, []);

  const value = {
    theme,
    colorTheme,
    isDarkMode: overrideTheme ? overrideTheme.type === "dark" : isDarkMode,
    drawerOpen,
    setHandleDrawer,
    changeColor,
    toggleDarkMode,
    forceTheme,
  };
  return (
    <ThemeContext.Provider value={value}>
      {props.children}
    </ThemeContext.Provider>
  );
}

export default ThemeContextProvider;
